import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

const KEY = "coffee_cart_v1";
const PROMO_KEY = "coffee_promo_v1";
const PROMO_TABLE = { RUDRA5: 5, RUDRA10: 5, LAUNCH5: 5, LAUNCH10: 5 };

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);
  const [promoCode, setPromoCode] = useState(() => localStorage.getItem(PROMO_KEY) || "");

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    localStorage.setItem(PROMO_KEY, promoCode);
  }, [promoCode]);

  const addItem = (item) => {
    setItems((prev) => {
      // Merge non-custom items with same blend + weight + grind
      if (!item.is_custom) {
        const idx = prev.findIndex(
          (p) => p.blend_id === item.blend_id && p.weight_g === item.weight_g && p.grind === item.grind
        );
        if (idx >= 0) {
          const copy = [...prev];
          copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + item.quantity };
          return copy;
        }
      }
      return [...prev, { ...item, _uid: Math.random().toString(36).slice(2) }];
    });
    setOpen(true);
  };

  const removeItem = (uid) => setItems((prev) => prev.filter((p) => p._uid !== uid));
  const updateQty = (uid, qty) =>
    setItems((prev) => prev.map((p) => (p._uid === uid ? { ...p, quantity: Math.max(1, qty) } : p)));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price_inr * i.quantity, 0);
  const discountPct = PROMO_TABLE[promoCode.trim().toUpperCase()] || 0;
  const discount = Math.round((subtotal * discountPct) / 100);
  const netSubtotal = subtotal - discount;
  const shipping = netSubtotal === 0 ? 0 : 80;
  const total = netSubtotal + shipping;
  const count = items.reduce((n, i) => n + i.quantity, 0);

  const value = useMemo(
    () => ({ items, addItem, removeItem, updateQty, clear, open, setOpen, subtotal, discount, discountPct, shipping, total, count, promoCode, setPromoCode }),
    [items, open, subtotal, discount, discountPct, shipping, total, count, promoCode]
  );

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}
